import React from "react";
import { makeIconDef } from "./makeIconDef";
export var BlankIconDef = {
    blank: makeIconDef('blank', {
        regular: function () { return React.createElement(React.Fragment, null); },
        filled: function () { return React.createElement(React.Fragment, null); },
    })
};
